import React from "react";
import g from "glamorous";

const Div = g.div({
  backgroundColor: `#3c4d68`,
  color: `white`,
  padding: `1em`,
  borderRadius: `6px`,
  display: `flex`,
  flexDirection: `column`,
  alignItems: `stretch`,
});

const Title = g.h4({
  margin: `0 auto .35em`,
  letterSpacing: `0.06em`,
  fontSize: `1.2em`,
});

const Text = g.p({
  fontSize: `.85em`,
  lineHeight: `1.4em`,
});

const Input = g.input({
  backgroundColor: `#3c4d68`,
  color: `white`,
  width: "99%",
  border: `none`,
  borderBottom: `2px solid white`,
  fontSize: `.85em`,
  marginBottom: `.5em`,
  transition: `all .3s`,
  ":focus": {
    letterSpacing: `.02em`,
    outline: `none`,
    transition: `all .3s`,
  },
});

const InputHidden = g.input({
  display: `none`,
});

const Textarea = g.textarea({
  backgroundColor: `#3c4d68`,
  color: `white`,
  width: "98%",
  border: `.12em solid white`,
  margin: `.8em 0 .5em`,
  fontSize: `.85em`,
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
  ":focus": {
    letterSpacing: `.02em`,
    outline: `none`,
    transition: `all .3s`,
  },
});

const Button = g.input({
  backgroundColor: `white`,
  border: `2px solid white`,
  color: `#3c4d68`,
  borderRadius: `5px`,
  marginTop: `.8em`,
  marginLeft: `auto`,
  padding: `.3em .7em .45em`,
  fontSize: `.8em`,
  fontWeight: `bold`,
  transition: `all .3s`,
  ":hover": {
    color: `white`,
    backgroundColor: `#3c4d68`,
    transition: `all .3s`,
  },
  ":focus": {
    outline: `none`,
    color: `white`,
    backgroundColor: `#3c4d68`,
    transition: `all .3s`,
  },
});

export default ({ ...props }) => (
  <Div>
    <Title>Get in touch</Title>
    <Text>
      For any request
      {props.about && <span> regarding {props.about}</span>}, do not hesitate to
      leave your contact information.
    </Text>
    <form action="https://formspree.io/f/mqkgdqrq" method="POST">
      <Input
        type="text"
        id="coordonnees"
        placeholder="Your email address or phone number"
        name="Coordonnees"
        aria-label="Your email address or phone number"
        onKeyPress={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      />
      <Input
        type="textarea"
        id="intervention"
        placeholder="Subject of your request"
        name="Intervention"
        aria-label="Subject of your request"
        onKeyPress={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      />
      <Textarea
        type="textarea"
        id="message"
        placeholder="Your message"
        name="Message"
        aria-label="Your message"
        css={{
          height: `130px`,
          padding: `.5em`,
          width: `94%`,
          borderRadius: `6px`,
        }}
        wrap="hard"
      />
      <InputHidden
        type="textarea"
        id="page"
        value={props.about}
        name="Page"
        aria-label="Page du site consultée"
      />
      <input type="hidden" name="_language" value="en" />
      <g.Div display={`flex`} justifyContent={`space-between`}>
        <Button type="submit" value="Send" />
      </g.Div>
    </form>
  </Div>
);
